// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"a8382926","455":"6d4ca90f","732":"76f3f27c","977":"b4ffebf0"}[chunkId] + ".chunk.js";
};